"use client"

import { createFileRoute } from "@tanstack/react-router"
import { AnnouncementList } from "@/features/feature-announcements/components/announcement-list"

export const Route = createFileRoute("/$store/_layout/admin_/feature-announcements")({
  component: FeatureAnnouncementsPage,
})

function FeatureAnnouncementsPage() {
  return (
    <div className="px-4 py-6 lg:px-6">
      <AnnouncementList />
    </div>
  )
}
